import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';

export default function TabButton({
  onChange,
  label,
  value,
  isSelected,
  className,
  styleButton,
}) {
  const ref = useRef();
  useEffect(() => {
    if (isSelected) {
      onChange({ value, ref });
    }
  }, [isSelected, onChange, value]);
  const handleClick = () => {
    onChange({ value, ref });
  };

  return (
    <S.SubRouteNavBarOption
      onClick={handleClick}
      ref={ref}
      className={className}
      isSelected={isSelected}
      {...styleButton}
    >
      {label}
    </S.SubRouteNavBarOption>
  );
}

TabButton.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isSelected: PropTypes.bool,
  className: PropTypes.string,
  styleButton: PropTypes.object,
};

TabButton.defaultProps = {
  onChange: () => {},
  label: null,
  value: '',
  isSelected: false,
  className: null,
  styleButton: {},
};
